module.exports = __webpack_public_path__ + "static/media/promo-b-1.b28051c4.png";